import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { spaceMixin, Heading, Text, Spacer, Alert } from '@zillow/constellation';

const gridSize = '18% 12% 27% 27% 16%;';

const StyledGridContainer = styled.div`
    display: grid;
    align-items: start;
    grid-template-columns: ${gridSize};
    overflow: hidden;
    overflow-y: scroll;
    margin-top: 10px;
`;

const StyledReportContainer = styled.div`
    max-height: 350px;
    overflow: hidden;
    overflow-y: scroll;
`;

const StyledGridEvenContainer = styled.div`
    display: grid;
    background-color: ${props => props.theme.constellation?.colors.gray200};
    align-items: start;
    grid-template-columns: ${gridSize};
`;

const StyledGridOddContainer = styled.div`
    display: grid;
    align-items: start;
    grid-template-columns: ${gridSize};
`;

const StyledHeader = styled.div`
    display: inline-block;
    padding: 10px;
    background-color: ${props => props.theme.constellation?.colors.gray400};
    min-height: ${spaceMixin('xs')};
`;

const StyledRow = styled.div`
    display: inline-block;
    padding: 5px 10px;
    text-overflow: ellipsis;
    overflow: hidden;
`;

const getContent = props => {
    let content = [];
    props.data.forEach((obj, i) => {
        const StyledGridContainer = i % 2 ? StyledGridEvenContainer : StyledGridOddContainer;
        content.push(
            <StyledGridContainer key={i}>
                <StyledRow>{obj.date}</StyledRow>
                <StyledRow>{obj.agentId}</StyledRow>
                <StyledRow title={obj.agentName}>{obj.agentName}</StyledRow>
                <StyledRow>
                    <a
                        href={'https://zodiac.zgtools.net/services/' + obj.zodiacServiceName}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {obj.zodiacServiceName}
                    </a>
                </StyledRow>
                <StyledRow>{obj.ticketCount}</StyledRow>
            </StyledGridContainer>
        );
    });
    return content;
};

const JiraTicketsCreatedPerDayByAgent = props => {
    const reportContent =
        props.data.length <= 0 ? (
            <Alert appearance="warning" body="No data found." />
        ) : (
            <Spacer>
                <Spacer marginTop="xs">
                    <Alert
                        body={
                            <Text>
                                Total number of records found: <strong>{props.data.length}</strong>
                            </Text>
                        }
                    />
                </Spacer>
                <StyledGridContainer>
                    <StyledHeader>Date</StyledHeader>
                    <StyledHeader>AgentId</StyledHeader>
                    <StyledHeader>AgentName</StyledHeader>
                    <StyledHeader>Zodiac Service Name</StyledHeader>
                    <StyledHeader>Tickets count</StyledHeader>
                </StyledGridContainer>
                <StyledReportContainer>{getContent(props)}</StyledReportContainer>
            </Spacer>
        );

    return (
        <div>
            <Heading level="4">JIRA_TICKET_CREATED per day, by agent :</Heading>
            {reportContent}
        </div>
    );
};

JiraTicketsCreatedPerDayByAgent.propTypes = {
    data: PropTypes.any,
};

JiraTicketsCreatedPerDayByAgent.defaultProps = {
    data: [],
};

export default JiraTicketsCreatedPerDayByAgent;
